export const FILTER_ALL = 'ALL';
export const FILTER_COMPLETE = 'COMPLETE';
export const FILTER_INCOMPLETE= 'INCOMPLETE';
